<div>
  <pre>{{displayModel?.content}}</pre>
</div>
